import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthService } from "./auth.service";
import { StorageService } from "./storage.service";
import { BenefitService } from "./corporate/benefit.service";
import { BenefitsEmployeeService } from "./corporate/benefitsEmployee.service";
import { CompanyService } from "./corporate/company.service";
import { CostCenterService } from "./corporate/costcenter.service";
import { EmployeeService } from "./corporate/employee.service";
import { EmployeeManagementService } from "./corporate/employeeManagement.service";
import { HierarchyLeaderService } from "./corporate/hierarchyLeader.service";
import { HourlyBasisService } from "./corporate/hourlyBasis.service";
import { InfringementService } from "./corporate/infringement.service";
import { PointTimeExceptionService } from "./corporate/pointTimeException.service";
import { PointTimePeriodService } from "./corporate/pointTimePeriod.service";
import { TimeOccurrenceService } from "./corporate/timeOccurrence.service";
import { TimeShiftHistoryService } from "./corporate/timeShiftHistory.service";
import { VacationScheduleService } from "./corporate/vacationSchedule.service";
import { VacationScheduleMetricsService } from "./corporate/vacationScheduleMetrics.service";
import { DocumentSignatureService } from "./documents/document-signature.service";
import { DocumentMockupService } from "./documents/documentmockup.service";
import { DomainService } from "./domain.service";
import { GeographyService } from "./geography.service";
import { HandleErrorService } from "./handleError.service";
import { ApplicantDocumentService } from "./hiring/applicant-document.service";
import { ApplicantService } from "./hiring/applicant.service";
import { DocumentTypeService } from "./hiring/document-type.service";
import { ExitInterviewService } from "./hiring/exitInterview.service";
import { HiringConfigService } from "./hiring/hiring-config.service";
import { OcrHiringSettingsService } from "./hiring/ocr-hiring-settings.service";
import { JobTitleService } from "./hiring/jobTitle.service";
import { JobTitleGroupService } from "./hiring/jobTitleGroup.service";
import { SalaryScaleService } from "./hiring/salaryScale.service";
import { TimeShiftService } from "./hiring/timeShift.service";
import { HttpService } from "./http.service";
import { PontoService } from "./ponto.service";
import { BatimentoService } from "./reports/batimento.service";
import { LaborReportService } from "./reports/labor-report.service";
import { ResetPasswordService } from "./reset-password.service";
import { BenefitProviderService } from "./corporate/benefitProvider.service";
import { UserService } from "./corporate/user.service";
import { CompanyRootService } from "./corporate/companyRoot.service";
import { OrganizationService } from "./corporate/organization.service";
import { AccessProfileService } from "./corporate/accessProfile.service";
import { DepartmentService } from "./corporate/department.service";
import { ExcusedAbsenceService } from "./corporate/excusedAbsence.service";
import { WorkHealthClinicService } from "./hiring/work-health-clinic.service";
import { FormBuilderService } from "./form-builder/form-builder.service";
import { JobTitleSeniorizationService } from "./hiring/jobTitleSeniorization.service";
import { ExitInterviewFormService } from "./hiring/exitInterview-form.service";
import { RoleService } from "./corporate/role.service";
import { JobTitleFamilyService } from "./hiring/jobTitleFamily.service";
import { JobTitleCompetenceService } from "./hiring/jobTitleCompetence.service";
import { RecruitmentService } from "./recruitment/recruitment.service";
import { RecruitmentCandidateService } from "./recruitment/recruitment-candidate.service";
import { EthicsChannelReportService } from "./ethics-channel/ethics-channel-report.service";
import { EthicsChannelConfigService } from "./ethics-channel/ethics-channel-config.service";
import { ProbationaryPeriodDecisionTypeService } from "./probationary-period/probationary-period-decision-type.service";
import { ProbationaryPeriodService } from "./probationary-period/probationary-period.service";
import { ProbationaryPeriodEmployeeService } from "./probationary-period/probationary-period-employee.service";
import { ExitInterviewSettingService } from "./hiring/exitInterview-setting.service";
import { CompanyFacilityService } from "./corporate/company-facility.service";
import { IntegrationLinkService } from "./corporate/integration-link.service";

@NgModule({
	declarations: [],
	imports: [CommonModule, BrowserAnimationsModule],
	providers: [
		StorageService,
		AuthService,
		CompanyService,
		CompanyFacilityService,
		OrganizationService,
		CompanyRootService,
		CostCenterService,
		DomainService,
		HiringConfigService,
		OcrHiringSettingsService,
		HttpService,
		GeographyService,
		PontoService,
		LaborReportService,
		ResetPasswordService,
		ApplicantService,
		ApplicantDocumentService,
		JobTitleService,
		JobTitleGroupService,
		JobTitleSeniorizationService,
		JobTitleFamilyService,
		JobTitleCompetenceService,
		RecruitmentService,
		RecruitmentCandidateService,
		SalaryScaleService,
		WorkHealthClinicService,
		BenefitService,
		AccessProfileService,
		RoleService,
		UserService,
		BenefitProviderService,
		BenefitsEmployeeService,
		DocumentMockupService,
		TimeShiftService,
		DocumentTypeService,
		BatimentoService,
		EmployeeService,
		TimeOccurrenceService,
		ExcusedAbsenceService,
		PointTimePeriodService,
		HourlyBasisService,
		TimeShiftHistoryService,
		InfringementService,
		EmployeeManagementService,
		VacationScheduleService,
		VacationScheduleMetricsService,
		PointTimeExceptionService,
		HandleErrorService,
		HierarchyLeaderService,
		ExitInterviewService,
		ExitInterviewFormService,
		ExitInterviewSettingService,
		DocumentSignatureService,
		DepartmentService,
		FormBuilderService,
		EthicsChannelConfigService,
		EthicsChannelReportService,
		ProbationaryPeriodDecisionTypeService,
		ProbationaryPeriodService,
		ProbationaryPeriodEmployeeService,
		IntegrationLinkService
	],
})
export class ServicesModule { }
